/*
 * COPYRIGHT:     Copyright © 2019 Xplorie LLC
 * Warning:       This product is protected by United States and international copyright laws.
 *                Unauthorized use or duplication of this software, in whole or in part, is prohibited.
 */

export const getInnerIndentOption = (isCircle, size) => (isCircle ? size / 2 : 1)

export const buildRadiusSize = wrapperSize => wrapperSize - 1
